import { SVGProps } from "react"

type Props = SVGProps<SVGSVGElement> & {
  size?: number
}

export const IconComponentProvider = ({ size = 24, ...props }: Props) => (
  <svg
    id="component_provider_svg__Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 44 44"
    xmlSpace="preserve"
    width={size}
    height={size}
    {...props}
  >
    <style>
      {
        ".component_provider_svg__st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}"
      }
    </style>
    <path
      className="component_provider_svg__st0"
      d="M6 36.8V13.6l16.1-7.1 16.1 7.1v23.2"
    />
    <path
      className="component_provider_svg__st0"
      d="M23.9 22.5H31v14.3H13.2V26.1h10.7"
    />
    <path
      className="component_provider_svg__st0"
      d="M23.9 36.8V20.7c0-.5-.2-.9-.5-1.3-.3-.3-.8-.5-1.3-.5h-3.6c-.5 0-.9.2-1.3.5-.3.3-.5.8-.5 1.3V26"
    />
  </svg>
)
